export { default as RestaurantDescription } from './RestaurantDescription'
export { default as RestaurantDescriptionSkeleton } from './Skeleton'
